import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { authenticator } from './authenticator'
import { debugMessage, queryString, isStaffEmail } from './common'
import {
  coerceAction,
  writeStoredAction,
  clearStoredAction,
  isQuickStartPayload,
  resolvePendingAction
} from './lib/pendingAction'
import { InitialLoader } from './components/Home/InitialLoader'

function Action() {
  const navigate = useNavigate()
  const { search } = useLocation()

  useEffect(() => {
    debugMessage('Mounted', 'Action')
    let cancelled = false

    const action = resolvePendingAction(queryString(search).action)

    async function processAction(raw) {
      const payload = coerceAction(raw)
      const token = authenticator.getToken()
      if (!(await authenticator.isAuthenticated()) && !token?.jwt) {
        debugMessage('Cannot process action, not authenticated, authenticator.signIn() ...', 'Action')
        await authenticator.signIn()
        return
      }
      if (cancelled) return

      if (payload.action === 'goto-unit') {
        debugMessage("'goto-unit' action found, redirecting to /home with the requested unit ...", 'Action')
        clearStoredAction()

        const params = new URLSearchParams({ hardwareId: payload.hardwareId })
        if (payload.date) params.set('date', payload.date)
        navigate(`/home?${params.toString()}`, { replace: true })
        return
      }

      if (isQuickStartPayload(payload)) {
        const email = authenticator.getUserDetails()?.email
        if (isStaffEmail(email)) {
          debugMessage('Staff session cannot run Quick Start, going to /home', 'Action')
          clearStoredAction()
          window.location.replace('/home')
          return
        }
        const next = {
          ...payload,
          action: 'quick-start'
        }
        writeStoredAction(next)
        debugMessage('Redirecting to /quick-start ...', 'Action')
        navigate(`/quick-start/?action=${encodeURIComponent(JSON.stringify(next))}`, { replace: true })
        return
      }

      debugMessage('No valid action found, redirecting to /home ...', 'Action')
      clearStoredAction()
      navigate({ pathname: '/home', search: '' }, { replace: true })
    }

    if (action && (action.action || isQuickStartPayload(action))) {
      writeStoredAction(action)
      debugMessage('Processing action ...', 'Action')
      debugMessage(action, 'Action')
      processAction(action)
    } else {
      debugMessage('No action found, redirecting to /home ...', 'Action')
      clearStoredAction()
      navigate({ pathname: '/home', search: '' }, { replace: true })
    }

    return () => {
      cancelled = true
    }
  }, [navigate, search])

  return <InitialLoader loading />
}

export { Action }
